var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hide)?_c('small',[_c('Msg',{attrs:{"id":"ospedali.form.legal.disclaimer"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }